var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeliveryVehicleIcon01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#009ADC;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M440.91,315.36h-86.1l14.2-115.63h23.25c25.68,0,58.12,38.44,54.97,64.12L440.91,315.36z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.6,317.89h-86.1c-1.4,0-2.39-1.13-2.22-2.53l14.2-115.63c0.17-1.4,1.44-2.53,2.84-2.53h23.25 c26.88,0,60.56,39.25,57.19,66.65l-6.32,51.51C443.27,316.76,442,317.89,440.6,317.89z M357.65,312.83h81.04l6.01-48.98 c3.04-24.75-28.51-61.59-52.75-61.59h-20.72L357.65,312.83z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M446.9,258.76h-61.88c-1.4,0-2.39-1.13-2.22-2.53l5.23-42.64c0.17-1.4,1.44-2.53,2.84-2.53h31.61l-0.62,5.06h-29.08 l-4.61,37.58h59.35L446.9,258.76z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "355.89,314.73 158.55,314.73 162.88,279.42 176.91,165.16 374.25,165.16  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.58,317.26H158.24c-1.4,0-2.39-1.13-2.22-2.53l18.36-149.57c0.17-1.4,1.44-2.53,2.84-2.53h197.34 c1.4,0,2.39,1.13,2.22,2.53l-18.36,149.57C358.25,316.13,356.98,317.26,355.58,317.26z M161.39,312.2h192.28l17.74-144.51H179.13 L161.39,312.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7284 -0.6851 0.6851 0.7284 -158.7301 227.741)",
    className: "st0",
    cx: 207.92,
    cy: 314.1,
    rx: 21.38,
    ry: 18.91
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.14,336.74c-12.48,0-21.39-10.16-19.86-22.64c1.53-12.48,12.94-22.64,25.42-22.64c12.48,0,21.39,10.16,19.86,22.64 C229.03,326.59,217.62,336.74,205.14,336.74z M210.08,296.52c-9.69,0-18.55,7.89-19.74,17.58c-1.19,9.69,5.73,17.58,15.42,17.58 s18.55-7.89,19.74-17.58C226.69,304.41,219.77,296.52,210.08,296.52z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7284 -0.6851 0.6851 0.7284 -107.4754 358.3092)",
    className: "st0",
    cx: 398.25,
    cy: 314.73,
    rx: 21.38,
    ry: 18.91
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.47,337.37c-12.48,0-21.39-10.16-19.86-22.64c1.53-12.48,12.94-22.64,25.42-22.64s21.39,10.16,19.86,22.64 C419.36,327.21,407.96,337.37,395.47,337.37z M400.41,297.15c-9.69,0-18.55,7.89-19.74,17.58c-1.19,9.69,5.73,17.58,15.42,17.58 s18.55-7.89,19.74-17.58C417.02,305.04,410.11,297.15,400.41,297.15z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "362.01,271.36 162.93,271.36 163.55,266.3 362.63,266.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M179.89,242.37l3.5-28.49h9.7c2.86,0,7.6,0.38,10.84,3.93c2.94,3.21,3.08,7.31,2.7,10.38 c-0.46,3.76-1.81,7.09-4.93,9.87c-2.54,2.26-6.6,4.32-11.47,4.32H179.89z M188.05,236.09h1.5c1.79,0,4.33-0.17,6.49-2.05 c1.05-0.9,2.51-2.69,2.9-5.85c0.33-2.65-0.21-4.91-1.45-6.24c-1.55-1.62-3.84-1.79-5.67-1.79h-1.8L188.05,236.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M227.42,220.16h-8.8l-0.58,4.74h8.33l-0.77,6.28h-8.33l-0.6,4.91h8.8l-0.77,6.28H208.5l3.5-28.49h16.19 L227.42,220.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M239.2,213.88l-2.73,22.21h8.89l-0.77,6.28h-16.28l3.5-28.49H239.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M258.2,213.88l-3.5,28.49h-7.39l3.5-28.49H258.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M268.19,213.88l4.71,17.34l9.05-17.34h8.03l-15.63,28.49h-5.77l-8.46-28.49H268.19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M307.31,220.16h-8.8l-0.58,4.74h8.33l-0.77,6.28h-8.33l-0.6,4.91h8.8l-0.77,6.28h-16.19l3.5-28.49h16.19 L307.31,220.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M323.24,213.88c2.14,0,4.83,0.34,6.66,2.52c1.42,1.67,1.93,4.14,1.65,6.41c-0.3,2.43-1.41,4.57-2.99,5.94 c-1.24,1.07-2.81,1.71-4.17,1.97l7.5,11.66h-9.19l-5.75-10.94l-1.34,10.94h-7.39l3.5-28.49H323.24z M317.52,226.65h1.41 c1.11,0,2.73-0.3,3.73-1.15c0.62-0.56,1.12-1.5,1.23-2.39c0.11-0.86-0.12-1.8-0.69-2.39c-0.6-0.68-1.79-1.11-3.41-1.11h-1.41 L317.52,226.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M340.25,228.7l-8.48-14.82h8.84l4.43,7.77l6.12-7.77h8.97l-12.46,14.82L346,242.37h-7.43L340.25,228.7z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M148.51,208.24H76.6c-1.56,0-2.82-1.26-2.82-2.82s1.26-2.82,2.82-2.82h71.91c1.56,0,2.82,1.26,2.82,2.82 S150.06,208.24,148.51,208.24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.24,230.94H52.82c-1.56,0-2.82-1.26-2.82-2.82s1.26-2.82,2.82-2.82h89.42c1.56,0,2.82,1.26,2.82,2.82 S143.8,230.94,142.24,230.94z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.97,253.65H80.62c-1.56,0-2.82-1.26-2.82-2.82c0-1.56,1.26-2.82,2.82-2.82h55.35c1.56,0,2.82,1.26,2.82,2.82 C138.79,252.39,137.53,253.65,135.97,253.65z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M258.14,199.24v5.88h-4.6v-17.75h7.35c1.54,0,3.14,0.29,4.5,1.6c1.38,1.33,1.65,2.82,1.65,4.31 c0,1.41-0.19,3.06-1.57,4.42c-1.38,1.36-3.03,1.54-4.42,1.54H258.14z M258.14,195.51h1.54c0.48,0,1.38-0.05,1.94-0.56 c0.56-0.48,0.59-1.2,0.59-1.62c0-0.48-0.05-1.12-0.53-1.6c-0.53-0.56-1.38-0.64-1.97-0.64h-1.57V195.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M277.78,202.14h-6.44l-1.2,2.98h-4.87l6.81-17.75h5.03l6.68,17.75h-4.92L277.78,202.14z M276.55,198.63 l-2-5.75l-1.94,5.75H276.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M292.5,187.37c1.33,0,3.03,0.21,4.34,1.57c1.01,1.04,1.52,2.58,1.52,3.99c0,1.52-0.53,2.85-1.41,3.7 c-0.69,0.67-1.62,1.06-2.45,1.22l5.56,7.27h-5.72l-4.42-6.81v6.81h-4.6v-17.75H292.5z M289.92,195.33h0.88 c0.69,0,1.68-0.19,2.24-0.72c0.35-0.35,0.59-0.93,0.59-1.49c0-0.53-0.21-1.12-0.61-1.49c-0.43-0.43-1.2-0.69-2.21-0.69h-0.88 V195.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M307.51,191.28v13.84h-4.6v-13.84h-3.78v-3.91h12.16v3.91H307.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M317.7,196.6l-6.41-9.24h5.51l3.35,4.84l3.22-4.84h5.59l-6.63,9.24v8.52h-4.63V196.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M209.06,205.12l3.03-17.87h4.58l3.62,9.54l3.83-9.54h4.63l2.68,17.87h-4.63l-1.31-10.29l-4.31,10.29h-1.85 l-4.13-10.29l-1.53,10.29H209.06z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M237.08,196.55l-6.46-9.29h5.54l3.38,4.88l3.24-4.88h5.63l-6.67,9.29v8.57h-4.66V196.55z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryVehicleIcon01);
export default __webpack_public_path__ + "static/media/Delivery_Vehicle_Icon-01.cb116c547a41918d95780a3a940b8d52.svg";
export { ForwardRef as ReactComponent };